var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconSyncProblem(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 12,
    width: 12,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m19.425 21.525-3.3-3.3q-.4.25-.787.463-.388.212-.838.362V18q.25-.1.463-.225.212-.125.437-.25L6.5 8.6q-.475.775-.737 1.662Q5.5 11.15 5.5 12.1q0 1.2.463 2.35.462 1.15 1.437 2.125L8.425 17.6v-3.025h1v4.775H4.65v-1h3.1L6.7 17.3q-1.15-1.15-1.675-2.488Q4.5 13.475 4.5 12.1q0-1.175.325-2.238.325-1.062.95-1.987l-3.3-3.3.725-.7L20.125 20.8Zm-1.175-5.45-.725-.725q.475-.75.725-1.625t.25-1.825q0-1.2-.462-2.35-.463-1.15-1.438-2.125L15.575 6.4v3.025h-1V4.65h4.775v1h-3.1L17.3 6.7q1.15 1.15 1.675 2.487.525 1.338.525 2.713 0 1.15-.325 2.2-.325 1.05-.925 1.975ZM8.625 6.45l-.7-.7q.375-.25.763-.45.387-.2.812-.35V6q-.25.1-.462.212-.213.113-.413.238Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSyncProblem);
export default __webpack_public_path__ + "static/media/IconSyncProblem.e745936d.svg";
export { ForwardRef as ReactComponent };